<section class="ipe-create-page">
  <div class="ipe-create-shell">
    <header class="ipe-create-header">
      <h1 class="ipe-create-title">IPE Test Creation</h1>
    </header>

    <form [formGroup]="testForm" class="ipe-create-form" (ngSubmit)="onCreateTest()">
      <!-- TEST DETAILS -->
      <section class="ipe-create-card">
        <h2 class="ipe-create-section-title">Test Details</h2>
        <div class="ipe-create-grid ipe-create-grid-3">
          <div class="ipe-field">
            <label class="ipe-label">State <span class="req">*</span></label>
            <div class="dropdown w-100">
              <button type="button"
                class="ipe-search-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                data-bs-toggle="dropdown" aria-expanded="false"
                data-field="stateName"
                [class.ipe-control-invalid]="isFieldInvalid('stateName')"
                [attr.title]="testForm.value.stateName || 'Select State'">
                <span class="ipe-search-dropdown-text">{{ testForm.value.stateName || 'Select State' }}</span>
              </button>
              <ul class="dropdown-menu w-100 ipe-create-dropdown-menu">
                <li class="ipe-dd-search">
                  <input type="text" class="form-control ipe-dd-input" placeholder="Search State"
                    [(ngModel)]="stateQuery" [ngModelOptions]="{standalone: true}"
                    (keyup)="filterStates()" (click)="$event.stopPropagation()">
                </li>
                <li class="ipe-dd-list">
                  <div class="ipe-dd-empty" *ngIf="!filteredStateList?.length">No State</div>
                  <ng-container *ngFor="let item of filteredStateList">
                    <ul class="ipe-dd-item" (click)="selectState(item)"
                      [class.ipe-dd-selected]="testForm.value.stateName === getStateLabel(item)"
                      [attr.title]="getStateLabel(item)">
                      <li class="ipe-dd-text">{{ getStateLabel(item) }}</li>
                      <li><i *ngIf="testForm.value.stateName === getStateLabel(item)" class="fa fa-check"></i></li>
                    </ul>
                  </ng-container>
                </li>
              </ul>
            </div>
            <div class="ipe-field-error" *ngIf="isFieldInvalid('stateName')">Please select State</div>
          </div>

          <div class="ipe-field">
            <label class="ipe-label">Academic Year <span class="req">*</span></label>
            <div class="dropdown w-100">
              <button type="button"
                class="ipe-search-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                data-bs-toggle="dropdown" aria-expanded="false"
                data-field="academicYear"
                [class.ipe-control-invalid]="isFieldInvalid('academicYear')"
                [attr.title]="testForm.value.academicYear || 'Select Academic Year'">
                <span class="ipe-search-dropdown-text">{{ testForm.value.academicYear || 'Select Academic Year' }}</span>
              </button>
              <ul class="dropdown-menu w-100 ipe-create-dropdown-menu">
                <li class="ipe-dd-search">
                  <input type="text" class="form-control ipe-dd-input" placeholder="Search Academic Year"
                    [(ngModel)]="academicYearQuery" [ngModelOptions]="{standalone: true}"
                    (keyup)="filterAcademicYears()" (click)="$event.stopPropagation()">
                </li>
                <li class="ipe-dd-list">
                  <div class="ipe-dd-empty" *ngIf="!filteredAcademicYearList?.length">No Academic Year</div>
                  <ng-container *ngFor="let item of filteredAcademicYearList">
                    <ul class="ipe-dd-item" (click)="selectAcademicYear(item)"
                      [class.ipe-dd-selected]="testForm.value.academicYear === getAcademicYearLabel(item)"
                      [attr.title]="getAcademicYearLabel(item)">
                      <li class="ipe-dd-text">{{ getAcademicYearLabel(item) }}</li>
                      <li><i *ngIf="testForm.value.academicYear === getAcademicYearLabel(item)" class="fa fa-check"></i></li>
                    </ul>
                  </ng-container>
                </li>
              </ul>
            </div>
            <div class="ipe-field-error" *ngIf="isFieldInvalid('academicYear')">Please select Academic Year</div>
          </div>

          <div class="ipe-field">
            <label class="ipe-label">Class <span class="req">*</span></label>
            <div class="dropdown w-100">
              <button type="button"
                class="ipe-search-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                data-bs-toggle="dropdown" aria-expanded="false"
                data-field="className"
                [class.ipe-control-invalid]="isFieldInvalid('className')"
                [attr.title]="testForm.value.className || 'Select Class'">
                <span class="ipe-search-dropdown-text">{{ testForm.value.className || 'Select Class' }}</span>
              </button>
              <ul class="dropdown-menu w-100 ipe-create-dropdown-menu">
                <li class="ipe-dd-search">
                  <input type="text" class="form-control ipe-dd-input" placeholder="Search Class"
                    [(ngModel)]="classQuery" [ngModelOptions]="{standalone: true}"
                    (keyup)="filterClasses()" (click)="$event.stopPropagation()">
                </li>
                <li class="ipe-dd-list">
                  <div class="ipe-dd-empty" *ngIf="!filteredClassList?.length">No Class</div>
                  <ng-container *ngFor="let item of filteredClassList">
                    <ul class="ipe-dd-item" (click)="selectClass(item)"
                      [class.ipe-dd-selected]="testForm.value.className === getClassLabel(item)"
                      [attr.title]="getClassLabel(item)">
                      <li class="ipe-dd-text">{{ getClassLabel(item) }}</li>
                      <li><i *ngIf="testForm.value.className === getClassLabel(item)" class="fa fa-check"></i></li>
                    </ul>
                  </ng-container>
                </li>
              </ul>
            </div>
            <div class="ipe-field-error" *ngIf="isFieldInvalid('className')">Please select Class</div>
          </div>

          <div class="ipe-field">
            <label class="ipe-label">Group <span class="req">*</span></label>
            <div class="dropdown w-100">
              <button type="button"
                class="ipe-search-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                data-bs-toggle="dropdown" aria-expanded="false"
                data-field="groupName"
                [class.ipe-control-invalid]="isFieldInvalid('groupName')"
                [attr.title]="testForm.value.groupName || 'Select Group'">
                <span class="ipe-search-dropdown-text">{{ testForm.value.groupName || 'Select Group' }}</span>
              </button>
              <ul class="dropdown-menu w-100 ipe-create-dropdown-menu">
                <li class="ipe-dd-search">
                  <input type="text" class="form-control ipe-dd-input" placeholder="Search Group"
                    [(ngModel)]="groupQuery" [ngModelOptions]="{standalone: true}"
                    (keyup)="filterGroups()" (click)="$event.stopPropagation()">
                </li>
                <li class="ipe-dd-list">
                  <div class="ipe-dd-empty" *ngIf="!filteredGroupList?.length">No Group</div>
                  <ng-container *ngFor="let item of filteredGroupList">
                    <ul class="ipe-dd-item" (click)="selectGroup(item)"
                      [class.ipe-dd-selected]="testForm.value.groupName === getGroupLabel(item)"
                      [attr.title]="getGroupLabel(item)">
                      <li class="ipe-dd-text">{{ getGroupLabel(item) }}</li>
                      <li><i *ngIf="testForm.value.groupName === getGroupLabel(item)" class="fa fa-check"></i></li>
                    </ul>
                  </ng-container>
                </li>
              </ul>
            </div>
            <div class="ipe-field-error" *ngIf="isFieldInvalid('groupName')">Please select Group</div>
          </div>

          <div class="ipe-field">
            <label class="ipe-label">Stream <span class="req">*</span></label>
            <div class="dropdown w-100">
              <button type="button"
                class="ipe-search-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                data-bs-toggle="dropdown" aria-expanded="false"
                data-field="streamName"
                [class.ipe-control-invalid]="isFieldInvalid('streamName')"
                [attr.title]="testForm.value.streamName || 'Select Stream'">
                <span class="ipe-search-dropdown-text">{{ testForm.value.streamName || 'Select Stream' }}</span>
              </button>
              <ul class="dropdown-menu w-100 ipe-create-dropdown-menu">
                <li class="ipe-dd-search">
                  <input type="text" class="form-control ipe-dd-input" placeholder="Search Stream"
                    [(ngModel)]="streamQuery" [ngModelOptions]="{standalone: true}"
                    (keyup)="filterStreams()" (click)="$event.stopPropagation()">
                </li>
                <li class="ipe-dd-list">
                  <div class="ipe-dd-empty" *ngIf="!filteredStreamList?.length">No Stream</div>
                  <ng-container *ngFor="let item of filteredStreamList">
                    <ul class="ipe-dd-item" (click)="selectStream(item)"
                      [class.ipe-dd-selected]="testForm.value.streamName === getStreamLabel(item)"
                      [attr.title]="getStreamLabel(item)">
                      <li class="ipe-dd-text">{{ getStreamLabel(item) }}</li>
                      <li><i *ngIf="testForm.value.streamName === getStreamLabel(item)" class="fa fa-check"></i></li>
                    </ul>
                  </ng-container>
                </li>
              </ul>
            </div>
            <div class="ipe-field-error" *ngIf="isFieldInvalid('streamName')">Please select Stream</div>
          </div>

          <div class="ipe-field">
            <label class="ipe-label">Program Name <span class="req">*</span></label>
            <div class="dropdown w-100">
              <button type="button"
                class="ipe-search-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                data-bs-toggle="dropdown" aria-expanded="false"
                data-field="programName"
                [class.ipe-control-invalid]="isFieldInvalid('programName')"
                [attr.title]="testForm.value.programName || 'Select Program'">
                <span class="ipe-search-dropdown-text">{{ testForm.value.programName || 'Select Program' }}</span>
              </button>
              <ul class="dropdown-menu w-100 ipe-create-dropdown-menu">
                <li class="ipe-dd-search">
                  <input type="text" class="form-control ipe-dd-input" placeholder="Search Program"
                    [(ngModel)]="programQuery" [ngModelOptions]="{standalone: true}"
                    (keyup)="filterPrograms()" (click)="$event.stopPropagation()">
                </li>
                <li class="ipe-dd-list">
                  <div class="ipe-dd-empty" *ngIf="!filteredProgramList?.length">No Program</div>
                  <ng-container *ngFor="let item of filteredProgramList">
                    <ul class="ipe-dd-item" (click)="selectProgram(item)"
                      [class.ipe-dd-selected]="testForm.value.programName === getProgramLabel(item)"
                      [attr.title]="getProgramLabel(item)">
                      <li class="ipe-dd-text">{{ getProgramLabel(item) }}</li>
                      <li><i *ngIf="testForm.value.programName === getProgramLabel(item)" class="fa fa-check"></i></li>
                    </ul>
                  </ng-container>
                </li>
              </ul>
            </div>
            <div class="ipe-field-error" *ngIf="isFieldInvalid('programName')">Please select Program</div>
          </div>

          <div class="ipe-field">
            <label class="ipe-label">Test Type <span class="req">*</span></label>
            <div class="dropdown w-100">
              <button type="button"
                class="ipe-search-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                data-bs-toggle="dropdown" aria-expanded="false"
                data-field="testType"
                [class.ipe-control-invalid]="isFieldInvalid('testType')"
                [attr.title]="testForm.value.testType || 'Select Test Type'">
                <span class="ipe-search-dropdown-text">{{ testForm.value.testType || 'Select Test Type' }}</span>
              </button>
              <ul class="dropdown-menu w-100 ipe-create-dropdown-menu">
                <li class="ipe-dd-search">
                  <input type="text" class="form-control ipe-dd-input" placeholder="Search Test Type"
                    [(ngModel)]="testTypeQuery" [ngModelOptions]="{standalone: true}"
                    (keyup)="filterTestTypes()" (click)="$event.stopPropagation()">
                </li>
                <li class="ipe-dd-list">
                  <div class="ipe-dd-empty" *ngIf="!filteredTestTypeList?.length">No Test Type</div>
                  <ng-container *ngFor="let item of filteredTestTypeList">
                    <ul class="ipe-dd-item" (click)="selectTestType(item)"
                      [class.ipe-dd-selected]="testForm.value.testType === getTestTypeLabel(item)"
                      [attr.title]="getTestTypeLabel(item)">
                      <li class="ipe-dd-text">{{ getTestTypeLabel(item) }}</li>
                      <li><i *ngIf="testForm.value.testType === getTestTypeLabel(item)" class="fa fa-check"></i></li>
                    </ul>
                  </ng-container>
                </li>
              </ul>
            </div>
            <div class="ipe-field-error" *ngIf="isFieldInvalid('testType')">Please select Test Type</div>
          </div>
        </div>
      </section>

      <!-- TEST DURATION -->
      <section class="ipe-create-card">
        <h2 class="ipe-create-section-title">Test Duration</h2>
        <div class="ipe-create-grid ipe-create-grid-2">
          <div class="ipe-field">
            <label class="ipe-label">Test Start Date <span class="req">*</span></label>
            <div class="ipe-date-wrap" (click)="openStartCalendar($event)">
              <input #startDateInput type="text" class="ipe-control"
                data-field="testStartDate"
                [value]="testForm.get('testStartDate')?.value || ''"
                [class.ipe-control-invalid]="isFieldInvalid('testStartDate')"
                placeholder="Select Start Date" readonly tabindex="0"
                (keydown.enter)="openStartCalendar($event)"
                (keydown.space)="openStartCalendar($event)" />
              <i class="fa fa-calendar ipe-date-icon" aria-hidden="true"></i>
            </div>
            <div class="ipe-field-error" *ngIf="isFieldInvalid('testStartDate')">Please select Test Start Date</div>
          </div>
          <div class="ipe-field">
            <label class="ipe-label">Test End Date <span class="req">*</span></label>
            <div class="ipe-date-wrap" (click)="openEndCalendar($event)">
              <input #endDateInput type="text" class="ipe-control"
                data-field="testEndDate"
                [value]="testForm.get('testEndDate')?.value || ''"
                [class.ipe-control-invalid]="isFieldInvalid('testEndDate')"
                placeholder="Select End Date" readonly tabindex="0"
                (keydown.enter)="openEndCalendar($event)"
                (keydown.space)="openEndCalendar($event)" />
              <i class="fa fa-calendar ipe-date-icon" aria-hidden="true"></i>
            </div>
            <div class="ipe-field-error" *ngIf="isFieldInvalid('testEndDate')">Please select Test End Date</div>
          </div>
        </div>
      </section>

      <!-- SUBJECT MAXIMUM MARKS -->
      <section class="ipe-create-card ipe-create-card-marks">
        <div class="ipe-marks-header">
          <h2 class="ipe-create-section-title">Subject Maximum Marks</h2>
          <label class="ipe-marks-check ipe-marks-select-all" *ngIf="subjects?.length">
            <input type="checkbox" class="ipe-subject-cb"
              [checked]="allSubjectsSelected"
              [indeterminate]="someSubjectsSelected"
              (change)="onSelectAllSubjects($event)">
            <span class="ipe-marks-label">Select All</span>
          </label>
        </div>
        <div class="ipe-dd-empty" *ngIf="!subjects?.length">
          Select State, Group and Test Type to load subjects
        </div>
        <div class="ipe-marks-grid" *ngIf="subjects?.length">
          <div class="ipe-marks-col">
            <div class="ipe-marks-field" *ngFor="let subject of leftSubjects">
              <div class="ipe-marks-row">
                <label class="ipe-marks-check">
                  <input type="checkbox" class="ipe-subject-cb"
                    [checked]="subject.selected"
                    [attr.data-subject-key]="subject.key"
                    (change)="onSubjectSelect(subject.key, $event)">
                  <span class="ipe-marks-label">{{ subject.label }} <span class="req" *ngIf="subject.selected">*</span></span>
                </label>
                <input type="text" inputmode="numeric" class="ipe-control ipe-marks-input"
                  [id]="subject.key"
                  [formControlName]="subject.key"
                  [class.ipe-control-invalid]="isSubjectInvalid(subject)"
                  (input)="onSubjectMarksInput(subject.key)"
                  maxlength="3" placeholder="Enter mark" />
              </div>
              <div class="ipe-field-error" *ngIf="isSubjectInvalid(subject)">
                {{ getSubjectError(subject) }}
              </div>
            </div>
          </div>
          <div class="ipe-marks-col">
            <div class="ipe-marks-field" *ngFor="let subject of rightSubjects">
              <div class="ipe-marks-row">
                <label class="ipe-marks-check">
                  <input type="checkbox" class="ipe-subject-cb"
                    [checked]="subject.selected"
                    [attr.data-subject-key]="subject.key"
                    (change)="onSubjectSelect(subject.key, $event)">
                  <span class="ipe-marks-label">{{ subject.label }} <span class="req" *ngIf="subject.selected">*</span></span>
                </label>
                <input type="text" inputmode="numeric" class="ipe-control ipe-marks-input"
                  [id]="subject.key"
                  [formControlName]="subject.key"
                  [class.ipe-control-invalid]="isSubjectInvalid(subject)"
                  (input)="onSubjectMarksInput(subject.key)"
                  maxlength="3" placeholder="Enter mark" />
              </div>
              <div class="ipe-field-error" *ngIf="isSubjectInvalid(subject)">
                {{ getSubjectError(subject) }}
              </div>
            </div>
          </div>
        </div>

        <div class="ipe-total-bar" *ngIf="subjects?.length">
          <span class="ipe-total-label">Total Marks</span>
          <span class="ipe-total-value">{{ totalMarks }}</span>
        </div>
      </section>

      <div class="ipe-create-api-error" *ngIf="createTestError">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
        <div class="ipe-create-api-error-text">
          <strong>Test already exists</strong>
          <span *ngIf="existingTestCode">
            Existing Test Code: <strong>{{ existingTestCode }}</strong>
          </span>
          <span *ngIf="existingTestName">
            Existing Test Name: <strong>{{ existingTestName }}</strong>
          </span>
          <span *ngIf="!existingTestCode && !existingTestName">{{ createTestError }}</span>
        </div>
      </div>

      <div class="ipe-create-actions">
        <button type="button" class="ipe-btn ipe-btn-outline" (click)="onReset()">
          <i class="fa fa-refresh" aria-hidden="true"></i>
          Reset
        </button>
        <button type="submit" class="ipe-btn ipe-btn-primary" [disabled]="isCreating">
          <i class="fa fa-save" aria-hidden="true"></i>
          {{ isCreating ? 'Creating...' : 'Create Test' }}
        </button>
      </div>
    </form>
  </div>
</section>

<div class="ipe-confirm-overlay" *ngIf="showCreateConfirm" (click)="closeCreateConfirm()">
  <div class="ipe-confirm-card" (click)="$event.stopPropagation()" role="dialog" aria-modal="true"
    aria-labelledby="ipeConfirmTitle">
    <div class="ipe-confirm-head">
      <div class="ipe-confirm-icon" aria-hidden="true">
        <i class="fa fa-check-circle"></i>
      </div>
      <div class="ipe-confirm-head-text">
        <h3 id="ipeConfirmTitle" class="ipe-confirm-title">Create this test?</h3>
        <p class="ipe-confirm-sub">Please review the details before creating.</p>
      </div>
      <button type="button" class="ipe-confirm-close" (click)="closeCreateConfirm()" aria-label="Close">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div class="ipe-confirm-body">
      <div class="ipe-confirm-grid">
        <div class="ipe-confirm-row" *ngFor="let row of confirmRows">
          <span class="ipe-confirm-label">{{ row.label }}</span>
          <span class="ipe-confirm-value" [title]="row.value">{{ row.value }}</span>
        </div>
      </div>
      <div class="ipe-confirm-subjects" *ngIf="confirmSubjectLabels.length">
        <span class="ipe-confirm-label">Subjects</span>
        <div class="ipe-confirm-chips">
          <span class="ipe-confirm-chip" *ngFor="let name of confirmSubjectLabels">{{ name }}</span>
        </div>
      </div>
    </div>

    <div class="ipe-confirm-actions">
      <button type="button" class="ipe-btn ipe-btn-outline" (click)="closeCreateConfirm()">Cancel</button>
      <button type="button" class="ipe-btn ipe-btn-primary" (click)="confirmCreateTest()">
        <i class="fa fa-check" aria-hidden="true"></i>
        Yes, Create Test
      </button>
    </div>
  </div>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 18px; color: white">Loading...</p>
</ngx-spinner>
